import { apiClient } from "./apiClient";

/* 내 계정 정보 조회 */
export const getMyAccount = async () => {
  const result = await apiClient("/api/user/account");

  return result?.data;
};

/* 내 비밀번호 변경 */
export const changeMyPassword = async ({
  currentPassword,
  newPassword,
  confirmPassword,
}) => {
  const result = await apiClient("/api/user/account/password", {
    method: "PATCH",
    body: JSON.stringify({
      currentPassword,
      newPassword,
      confirmPassword,
    }),
  });

  return result?.data;
};